<template>
  <infoBlock class="profile-regalia" :title="$t('labels.note')" marker-color="#A7CBE5">
    <div class="profile-regalia__container">
      <template v-if="regalia">
        <div v-if="regalia.length > excerptLength && !visibleExcerpt"
          class="profile-regalia__excerpt">
          <span>{{regalia | truncate(excerptLength)}}</span>
        </div>
        <div v-if="regalia.length < excerptLength || visibleExcerpt"
             class="profile-regalia__text">
          <span>{{ regalia }}</span>
        </div>
        <div class="profile-regalia__more-link" v-if="regalia.length > excerptLength">
          <span @click="visibleExcerpt = !visibleExcerpt" v-if="!visibleExcerpt">{{ $t('labels.more') }}</span>
          <span @click="visibleExcerpt = !visibleExcerpt" v-if="visibleExcerpt">{{ $t('labels.hide') }}</span>
        </div>
      </template>
      <div v-else class="profile-regalia__text">{{ $t('labels.not_specified') }}</div>
    </div>
  </infoBlock>
</template>
<script>
  import infoBlock from 'src/components/InfoBlock/InfoBlock.vue'
  export default {
    props: ['regalia'],
    components: {
      infoBlock
    },
    data () {
      return {
        visibleExcerpt: false,
        excerptLength: 180
      }
    },
    methods: {
      showRegalia () {

      }
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';

.profile-regalia {
  &:before {
    background: #A7CBE5;
  }

  &__container {
    position: relative;
  }

  &__text {
    position: relative;
    white-space: pre-line;
  }

  &__excerpt {
    white-space: initial;
  }

  &__more-link {
    text-align: right;
    padding-top: 10px;
    span {
      color: $link-color;
      cursor: pointer;
      &:hover {
        color: $link-color-hover;
      }
    }
  }
}
</style>